/**
 * This guard denies access to route for users with 'Admin' role
 */

import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router'
import { ADD_WAYPOINT_VIEW_PARAM_KEY } from './constants'
import { NetworkNodeType } from './network_node.model'

export const ADD_WAYPOINT_TYPES = new Set<NetworkNodeType>([
  NetworkNodeType.Waypoint,
  NetworkNodeType.Semaphore,
  NetworkNodeType.Delivery,
])

@Injectable()
export class AddWaypointParamsGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const type = route.paramMap.get(ADD_WAYPOINT_VIEW_PARAM_KEY)

    if (ADD_WAYPOINT_TYPES.has(type as NetworkNodeType)) {
      return true
    } else {
      this.router.navigateByUrl(NetworkNodeType.Waypoint)
      return false
    }
  }
}
